import { useEffect, useState } from 'react';
import api from '../ui/api';

// العام الدراسي — the one current school year (api/src/lib/year.js).
// Shared across the app: the top bar and the About page read the same
// value, and an edit on one shows up on the other at once.

let current = null;
let pending = null;
const listeners = new Set();

function publish(year) {
  current = year;
  listeners.forEach((fn) => fn(year));
}

function load() {
  if (!pending) {
    pending = api.academicYears()
      .then((list) => { publish(Array.isArray(list) ? list[0] || null : null); })
      .catch(() => { pending = null; });
  }
  return pending;
}

export async function saveSchoolYear(id, patch) {
  const year = await api.updateAcademicYear(id, patch);
  publish(year);
  return year;
}

export default function useSchoolYear() {
  const [year, setYear] = useState(current);
  useEffect(() => {
    listeners.add(setYear);
    if (!current) load();
    return () => { listeners.delete(setYear); };
  }, []);
  return year;
}
